import config from 'config/app.config'
import { USER_SESSION_DISCONNECT } from 'socket-resources/event-constants/common-events'
import { io } from 'socket.io-client'

/**
 * listenUserSessionDisconnect
 * @param {function} cb - callback for USER_SESSION_DISCONNECT event
 * @param {string} authToken - user auth token
 * @param {function} [onSocketDisconnect] - callback for socket disconnect/connect_error
 * @param {function} [onSocketReconnect] - callback for socket reconnect/connect
 */
const useUserSessionSocketNameSpace = () => {
  const listenUserSessionDisconnect = (cb, authToken, onSocketDisconnect, onSocketReconnect) => {
    const userSessionSocketInstance = io(`${config.SOCKET_URL}/user-session`, {
      transports: ['polling', 'websocket'],
      auth: {
        authorization: `Bearer ${authToken}`
      }
    })
    if (cb) {
      userSessionSocketInstance.on(USER_SESSION_DISCONNECT, cb)
    }
    if (onSocketDisconnect) {
      userSessionSocketInstance.on('disconnect', onSocketDisconnect)
      userSessionSocketInstance.on('connect_error', onSocketDisconnect)
    }
    if (onSocketReconnect) {
      userSessionSocketInstance.on('reconnect', onSocketReconnect)
      userSessionSocketInstance.on('connect', onSocketReconnect)
    }
    return () => {
      userSessionSocketInstance.off(USER_SESSION_DISCONNECT, cb)
      if (onSocketDisconnect) {
        userSessionSocketInstance.off('disconnect', onSocketDisconnect)
        userSessionSocketInstance.off('connect_error', onSocketDisconnect)
      }
      if (onSocketReconnect) {
        userSessionSocketInstance.off('reconnect', onSocketReconnect)
        userSessionSocketInstance.off('connect', onSocketReconnect)
      }
    }
  }

  return listenUserSessionDisconnect
}

export default useUserSessionSocketNameSpace
